import { FlagsComponentRouter, FlagsSingleton } from 'flags'
import {
  isDigitalWellBeingUrl,
  isMiddleSchoolUrl,
  isMiddleSchoolDashboard,
  isK5Url,
  isK5Dashboard,
} from 'utils/productHelpers'

import OffComponent from './flag.off'
import OnComponent from './flag.on'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature_LEARN-20164-k5-site-selection'],
  OnComponent,
  OffComponent,
  flagsChecker: FlagsSingleton.checkAtLeastOneFlagTrue,
  onCondition: (_, subscribedFlags) => {
    const isMiddleSchool = isMiddleSchoolUrl() || isMiddleSchoolDashboard()

    const isK5 =
      (isK5Url() || isK5Dashboard()) &&
      subscribedFlags['feature_LEARN-20164-k5-site-selection']

    return isMiddleSchool || isK5 || isDigitalWellBeingUrl()
  },
})

export default FlagToggler
